import React from "react";
import { Modal } from "antd-mobile";
import "./index.less";
import { viewPort } from "../../../../../utils/util";
import InsuranceDetailModal from "../insuranceDetailModal";
import InsurancePremiumModal from "../insurancePremiumModal";

class CarPurchaseModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expandedIndex: -1,
      insuranceDetailModalVisible: false,
      insuranceDetailModalData: {},
      insurancePremiumModalVisible: false,
      insurancePremiumModalData: {},
    };
  }

  toggleExpand(index) {
    this.setState({
      expandedIndex: this.state.expandedIndex === index ? -1 : index,
    });
  }

  openInsuranceDetailModal(data) {
    this.setState({
      insuranceDetailModalVisible: true,
      insuranceDetailModalData: data || {},
    });
  }

  closeInsuranceDetailModal() {
    this.setState({
      insuranceDetailModalVisible: false,
      insuranceDetailModalData: {},
    });
  }

  openInsurancePremiumModal(data) {
    this.setState({
      insurancePremiumModalVisible: true,
      insurancePremiumModalData: data || {},
    });
  }

  closeInsurancePremiumModal() {
    this.setState({
      insurancePremiumModalVisible: false,
      insurancePremiumModalData: {},
    });
  }

  openCarRentalDetailPage(rentalCode) {
    if (!rentalCode) return;
    const vp = viewPort();
    if (vp.ios || vp.iPhone || vp.iPad) {
      if (window.webkit) {
        window.webkit.messageHandlers.openCarRentalDetailPage.postMessage({
          rentalcode: rentalCode,
        });
      }
    } else {
      if (window.huilian) {
        window.huilian.openCarRentalDetailPage(rentalCode);
      }
    }
  }

  openInsuranceDetailPage(compulsoryInsuranceId) {
    if (!compulsoryInsuranceId) return;
    const vp = viewPort();
    if (vp.ios || vp.iPhone || vp.iPad) {
      if (window.webkit) {
        window.webkit.messageHandlers.openInsuranceDetailPage.postMessage({
          hcmInsuranceId: compulsoryInsuranceId,
        });
      }
    } else {
      if (window.huilian) {
        window.huilian.openInsuranceDetailPage(compulsoryInsuranceId);
      }
    }
  }

  render() {
    const { visible, onClose, data } = this.props;
    const { expandedIndex } = this.state;

    const { type, levelTwo } = data;
    const cars = data.cars || [];

    // 计算提前结清优惠
    const calcAdvancePreference = (item) => {
      return (
        Number(item.advancePreferenceMonth || 0) *
        Number(item.advancePreferencePrice || 0)
      ).toFixed(2);
    };

    const calcActualReferencePrice = (item) => {
      const result =
        Number(item.referencePrice || 0) -
        Number(calcAdvancePreference(item) || 0);
      return Number(result.toFixed(2)) || 0;
    };

    return (
      <Modal
        visible={visible}
        onClose={onClose}
        maskClosable={true}
        closable={false}
        transparent
        style={{
          width: "100%",
          position: "fixed",
          bottom: 0,
          left: 0,
          height: "70%",
          borderRadius: "0.08rem 0.08rem 0 0",
          display: "flex",
          flexDirection: "column",
          zIndex: 1000,
        }}
        wrapStyle={{ zIndex: 1000 }}
        bodyStyle={{
          padding: 0,
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <div className="modalHeader">
          <span className="modalTitle">购车清单({cars.length})</span>
          <span className="modalClose" onClick={onClose}>
            ×
          </span>
        </div>
        <div className="modalBody">
          {cars.map((item, index) => (
            <div className="carItem" key={index}>
              <div
                className="carSummary"
                onClick={() => this.toggleExpand(index)}
              >
                <div className="carInfo">
                  <span className="carPlate">{item.carPlateNumber}</span>
                  <span className="carVin">
                    (VIN码：{item.deviceId || "-"})
                  </span>
                </div>
                <div className="carPriceRow">
                  <div className="carPriceGroup">
                    {levelTwo === "ywys-tqxs-jcyzg" ||
                    levelTwo === "ywys-tqxs-xcyzg" ||
                    ((levelTwo === "ywys-yzgj" || levelTwo === "ywys-yzgx") &&
                      type === "ERENT_SALE") ? (
                      <span>
                        <span
                          className={`carPrice ${item.referencePrice != null && item.salePrice != null && Number(item.salePrice) !== calcActualReferencePrice(item) ? "priceRed" : ""}`}
                        >
                          销售价(元)：
                          {item.salePrice != null ? item.salePrice : "-"}
                        </span>
                        {<span className="priceDivider">|</span>}
                        {
                          <span className="carPrice">
                            参考销售价(元)：
                            {item.referencePrice != null
                              ? calcActualReferencePrice(item)
                              : "-"}
                          </span>
                        }
                      </span>
                    ) : (
                      <span className="carPrice">
                        销售价(元)：
                        {item.salePrice != null ? item.salePrice : "-"}
                      </span>
                    )}
                  </div>
                  <span
                    className={`expandIcon ${expandedIndex === index ? "expanded" : ""}`}
                  ></span>
                </div>
              </div>
              {expandedIndex === index && (
                <div className="carDetail">
                  {/* <!-- 注：只是,ERENT_SALE:易租购 -->
                      <!-- | **慧租车（易租购、<s>租转购</s>）-旧车** | `ywys-yzgj`| -->
                      <!-- | **慧租车（易租购、<s>租转购</s>）-新车** | `ywys-yzgx`| -->
                      <!-- | **慧租车（提前销售）-旧车易租购** | `ywys-tqxs-jcyzg` | -->
                      <!-- | **慧租车（提前销售）-新车易租购** | `ywys-tqxs-xcyzg` | --> */}
                  {type === "ERENT_SALE" &&
                    (levelTwo === "ywys-yzgj" ||
                      levelTwo === "ywys-yzgx" ||
                      levelTwo === "ywys-tqxs-jcyzg" ||
                      levelTwo === "ywys-tqxs-xcyzg") && (
                      <div>
                        {item.referencePrice != null &&
                          item.salePrice != null &&
                          Number(item.salePrice) !==
                            calcActualReferencePrice(item) && (
                            <div className="detailRow">
                              <span className="priceRed">
                                销售价与参考销售价不一致，请注意查看！
                              </span>
                            </div>
                          )}
                        <div className="detailRow">
                          <span className="detailLabel">车型：</span>
                          <span className="detailValue">
                            {item.carTypeName || "-"}
                          </span>
                        </div>
                        <div className="detailRow">
                          <span className="detailLabel">租车订单号：</span>
                          <span className="detailValue">
                            {item.rentalCode || "-"}
                          </span>
                          {item.rentalCode && (
                            <span
                              className="detailLink"
                              onClick={() =>
                                this.openCarRentalDetailPage(item.rentalCode)
                              }
                            >
                              查看租车详情
                            </span>
                          )}
                        </div>
                        <div className="detailRow">
                          <span className="detailLabel">
                            租车订单要求保证金(元)：
                          </span>
                          <span className="detailValue">
                            {item.handsel != null ? item.handsel : "-"}
                          </span>
                        </div>
                        <div className="detailRow">
                          <span className="detailLabel">销售日期：</span>
                          <span className="detailValue">
                            {item.saleDate || "-"}
                          </span>
                        </div>
                        {/* 提前销售-旧车易租购、新车易租购 */}
                        {["ywys-tqxs-jcyzg", "ywys-tqxs-xcyzg"].includes(
                          levelTwo,
                        ) && (
                          <div>
                            <div className="detailRow">
                              <span className="detailLabel">
                                销售日期后租金(元)：
                              </span>
                              <span className="detailValue">
                                {item.afterSalePrice != null
                                  ? item.afterSalePrice
                                  : "-"}
                              </span>
                            </div>
                          </div>
                        )}
                        <div className="detailRow">
                          <span className="detailLabel">预计尾款(元)：</span>
                          <span className="detailValue">
                            {item.downPaymentAmount != null
                              ? item.downPaymentAmount
                              : "-"}
                          </span>
                        </div>
                        <div className="detailRow">
                          <span className="detailLabel">慧代保(元)：</span>
                          <span className="detailValue">
                            {item.agentInsuranceAmount != null
                              ? item.agentInsuranceAmount
                              : "-"}
                          </span>
                          {item.agentInsuranceAmount != null && (
                            <span
                              className="detailLink"
                              onClick={() =>
                                this.openInsurancePremiumModal(item)
                              }
                            >
                              查看投保明细
                            </span>
                          )}
                        </div>
                        {["ywys-yzgj", "ywys-yzgx", "ywys-tqxs-jcyzg"].includes(
                          levelTwo,
                        ) && (
                          <div className="detailRow">
                            <span className="detailLabel">
                              起租前剩余保险(元)：
                            </span>
                            <span className="detailValue">
                              {item.surplusInsuranceAmount != null
                                ? item.surplusInsuranceAmount
                                : "-"}
                            </span>
                            {item.surplusInsuranceAmount != null && (
                              <span
                                className="detailLink"
                                onClick={() =>
                                  this.openInsuranceDetailModal(item)
                                }
                              >
                                查看
                              </span>
                            )}
                          </div>
                        )}
                        {["ywys-tqxs-jcyzg", "ywys-tqxs-xcyzg"].includes(
                          levelTwo,
                        ) && (
                          <div>
                            <div className="detailRow">
                              <span className="detailLabel">
                                提前结清优惠(元)：
                              </span>
                              <span className="detailValue">
                                {item.advancePreferenceMonth != null &&
                                item.advancePreferencePrice != null
                                  ? calcAdvancePreference(item)
                                  : "0.00"}
                              </span>
                            </div>
                            <div className="detailRow">
                              <span className="detailLabel">优惠月数：</span>
                              <span className="detailValue">
                                {item.advancePreferenceMonth || "-"}
                              </span>
                            </div>
                            <div className="detailRow">
                              <span className="detailLabel">
                                每月优惠金额(元)：
                              </span>
                              <span className="detailValue">
                                {item.advancePreferencePrice != null
                                  ? item.advancePreferencePrice
                                  : "-"}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                  {/*  | **慧租车（销售）-其他** | `ywys-xs-qt`|  */}
                  {levelTwo === "ywys-xs-qt" && (
                    <div>
                      <div className="detailRow">
                        <span className="detailLabel">车型全称：</span>
                        <span className="detailValue">
                          {item.carTypeNameNew || "-"}
                        </span>
                      </div>
                      <div className="detailRow">
                        <span className="detailLabel">车型：</span>
                        <span className="detailValue">
                          {item.carTypeName || "-"}
                        </span>
                      </div>
                      <div className="detailRow">
                        <span className="detailLabel">销售日期：</span>
                        <span className="detailValue">
                          {item.saleDate || "-"}
                        </span>
                      </div>
                      <div className="detailRow">
                        <span className="detailLabel">行驶证注册日期：</span>
                        <span className="detailValue">
                          {item.drivingLicenseRegisterDate || "-"}
                        </span>
                      </div>
                      <div className="detailRow">
                        <span className="detailLabel">尾板：</span>
                        <span className="detailValue">
                          {item.tailBoardAssetCode || "-"}
                        </span>
                      </div>
                      <div className="detailRow">
                        <span className="detailLabel">
                          保险到期时间(交强险)：
                        </span>
                        <span className="detailValue">
                          {item.compulsoryInsuranceExpireDate || "-"}
                        </span>
                        {item.compulsoryInsuranceId && (
                          <span
                            className="detailLink"
                            onClick={() =>
                              this.openInsuranceDetailPage(
                                item.compulsoryInsuranceId,
                              )
                            }
                          >
                            查看保险明细
                          </span>
                        )}
                      </div>
                      <div className="detailRow">
                        <span className="detailLabel">保险公司(交强险)：</span>
                        <span className="detailValue">
                          {item.compulsoryInsuranceCompany || "-"}
                        </span>
                      </div>
                    </div>
                  )}
                  {!(
                    (type === "ERENT_SALE" &&
                      [
                        "ywys-yzgj",
                        "ywys-yzgx",
                        "ywys-tqxs-jcyzg",
                        "ywys-tqxs-xcyzg",
                      ].includes(levelTwo)) ||
                    levelTwo === "ywys-xs-qt"
                  ) && (
                    <div>
                      {item.carTypeNameNew && (
                        <div className="detailRow">
                          <span className="detailLabel">车型全称：</span>
                          <span className="detailValue">
                            {item.carTypeNameNew || "-"}
                          </span>
                        </div>
                      )}

                      <div className="detailRow">
                        <span className="detailLabel">车型：</span>
                        <span className="detailValue">
                          {item.carTypeName || "-"}
                        </span>
                      </div>
                      <div className="detailRow">
                        <span className="detailLabel">车辆定金(元/台)：</span>
                        <span className="detailValue">
                          {item.handsel != null ? item.handsel : "-"}
                        </span>
                      </div>
                      <div className="detailRow">
                        <span className="detailLabel">销售日期：</span>
                        <span className="detailValue">
                          {item.saleDate || "-"}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
        <InsuranceDetailModal
          visible={this.state.insuranceDetailModalVisible}
          onClose={() => this.closeInsuranceDetailModal()}
          data={this.state.insuranceDetailModalData}
        />
        <InsurancePremiumModal
          visible={this.state.insurancePremiumModalVisible}
          onClose={() => this.closeInsurancePremiumModal()}
          data={this.state.insurancePremiumModalData}
        />
      </Modal>
    );
  }
}

export default CarPurchaseModal;



// WEBPACK FOOTER //
// ./src/processReview/modules/types/CAR_PURCHASE_LIST/carPurchaseModal/index.js